<template>
  <div class="IncrementalData-fieldWrap">
    <div class="IncrementalData-field">
      <p class="IncrementalData-supportingText">
        Tell us when you started school so we can personalise your job alerts.
      </p>
      <div
        class="IncrementalData-question"
        data-rmpdev-selector="uniYear-field"
      >
        <label
          for="start-year"
          class="IncrementalData-questionText"
        >
          What year did you start secondary school? *
        </label>
        <div class="IncrementalData-questionField">
          <form-autocomplete
            v-model="fields.institution_start_year"
            :required="true"
            :items="institutionStartYears"
            :error="validateStatus({ field: v$.fields.institution_start_year, serverKey: 'institution_start_year', label: 'Secondary school start year' })"
            :searchable="false"
            :manual-validate="validateAll"
            data-rmpdev-field-selector="institution_start_year"
            placeholder="Select your school year"
            @change="validateBlur({ field: v$.fields.institution_start_year, serverKey: 'institution_start_year' })"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import FormAutocomplete from '@/components/form/autocomplete-select';
import useVuelidate from '@vuelidate/core';
import incrementalMixin from '../mixins/incremental-data-field-mixin';

export default {
  components: {
    FormAutocomplete,
  },

  mixins: [incrementalMixin],

  data() {
    return {
      v$: useVuelidate(),
      fields: {
        institution_start_year: null,
      },
      fieldName: 'institution_start_year',
    };
  },

  computed: {
    ...mapState('entities', {
      institutionStartYears: (state) => state.institutionStartYears,
    }),
    updatePayload() {
      return {
        institution_start_year: this.fields.institution_start_year.value,
      };
    },
  },

  mounted() {
    this.getInstitutionStartYears();
  },

  methods: {
    ...mapActions('entities', {
      getInstitutionStartYears: 'getInstitutionStartYears',
    }),
  },
};
</script>
